import { ASPECT_RATIO, gridPhotos } from '@app/components/package-customize/customize-sheet-item/sheet/utils';

export default {
  nameDesc: '2 - 3x5',
  imageCount: 2,
  displayGroup: 'DG_3X5',
  calc: (height) => {
    const pWidth = height / ASPECT_RATIO / 2;
    const pHeight = height / 2;

    return {
      gridTemplate: `
        'p1 .' ${pHeight}px
        'p2 .' ${pHeight}px
        / ${pWidth}px ${pWidth}px`,
      photos: gridPhotos(1, 2, pWidth, pHeight)
    };
  }
};
